import { Suspense, lazy } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { CardSkeleton } from '@/components/ui/Skeleton'
import { ComingSoonPage } from '@/pages/ComingSoonPage'
import { useStoreGate } from '@/contexts/StoreGateContext'
import { StoreLayout } from '@/store/components/layout/StoreLayout'
import {
  resolveStorePageLoader,
  StorePageLoader,
} from '@/store/components/StorePageLoader'
import { AdminRoutes } from './adminRoutes'
import { StoreRoutes } from './storeRoutes'

const ContactPage = lazy(() =>
  import('@/store/pages/ContactPage').then((m) => ({ default: m.ContactPage }))
)

function AdminPageLoader() {
  return (
    <div className="space-y-4 p-6">
      <CardSkeleton />
      <CardSkeleton />
    </div>
  )
}

function AppPageLoader() {
  const { pathname } = useLocation()
  if (resolveStorePageLoader(pathname)) {
    return <StorePageLoader />
  }
  return <AdminPageLoader />
}

export function AppRoutes() {
  const { status, showComingSoonPage } = useStoreGate()
  const { pathname } = useLocation()

  if (status === 'loading') {
    if (resolveStorePageLoader(pathname)) {
      return <StorePageLoader />
    }
    return <AdminPageLoader />
  }

  return (
    <Suspense fallback={<AppPageLoader />}>
      <Routes>
        {showComingSoonPage ? (
          <>
            <Route path="/" element={<ComingSoonPage />} />
            <Route element={<StoreLayout />}>
              <Route path="/contact" element={<ContactPage />} />
            </Route>
            {AdminRoutes()}
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        ) : (
          <>
            {StoreRoutes()}
            {AdminRoutes()}
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        )}
      </Routes>
    </Suspense>
  )
}
